import { VisitCompletionType } from './VisitCompletionType';

export enum VisitStatus {
  Check_In = 1,
  Consultation = 2,
  VetServices = 3,
  Check_Out = 4,
  In_Progress = 10,
  Admitted = 20,
  Finalized = 30,
  Paid = 40,
}

export enum VisitStatusString {
  Check_In = 'Check-In',
  Consultation = 'Consultation',
  VetServices = 'Vet Services',
  Check_Out = 'Check-Out',
}

export namespace VisitStatus {
  export const statusFormattedName = (
    status: string | number | undefined,
    visitCompletionTypeId?: number | undefined,
  ) => {
    if (typeof status === 'number') status = VisitStatus[status];
    if (!status) return 'Unknown';

    switch (status) {
      case 'Check_In':
        return 'Checked-in';
      case 'In_Progress':
        return 'In Progress';
      case 'VetServices':
        return 'Vet Services';
      case 'Check_Out':
        if (VisitCompletionType.visitIsAborted(visitCompletionTypeId))
          return 'Aborted';
        else return 'Completed';
      default:
        return status; //Consultation, Admitted, Finalized, Paid
    }
  };
}
